export default "__VITE_ASSET__6b85393d__"